module.exports = __webpack_public_path__ + "static/img/number_05@2x.8ab6bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/number_05@2x.png
// module id = PPS3
// module chunks = 0